import React, {useState} from "react"
import {useNavigate} from "react-router-dom"
import GoBack from "../subsidiary/GoBack/GoBack"
import styles from './Login.module.css'
import Button from '@mui/material/Button'
import incomingCall from '../../assets/img/incomingCall.svg'
import outCall from '../../assets/img/outGoingCall.svg'

const Login = () => {
    const navigation = useNavigate()
    const submitHandler = (e, type) => {
        if (type === 'incoming') {
            navigation('/login/incomingCall')
        } else {
            navigation('/login/outGoingCall')
        }
    }

    return (
        <section className={'main ' + styles.loginPage}>
            <GoBack text='Назад'/>
            <div className="content-wrapper">
                <form name="form1" className={styles.formWrapper}>
                    <h1 className={"page-title " + styles.title}>
                        Выберите <br/> предпочтительный<br/> способ авторизации
                    </h1>
                    <div className={styles.call_option}>
                        <div className={styles.call_description_container}>
                            <img src={incomingCall} alt=""/>
                            <span className={styles.call_description}>
                            Для входа потребуется указать ваш номер, получить звонок <span
                                style={{fontWeight: 700}}>и ввести последние
                            4 цифры входящего номера.</span>
                        </span>
                        </div>
                        <Button onClick={(e) => submitHandler(e, 'incoming')} className={styles.sendBtn} variant="contained">
                            Входящий звонок
                        </Button>
                    </div>
                    <div className={styles.call_option}>
                        <div className={styles.call_description_container}>
                            <img src={outCall} alt=""/>
                            <span className={styles.call_description}>
                            Укажите ваш номер, нажмите кнопку, чтобы
                            <span style={{fontWeight: 700}}> получить номер для звонка</span>
                            , позвоните на него — вход выполнится автоматически.
                        </span>
                        </div>
                        <Button onClick={(e) => submitHandler(e, 'outgoing')} className={styles.sendBtn} variant="contained">
                            Исходящий звонок
                        </Button>
                    </div>
                </form>
            </div>
        </section>
    )
}
export default Login
